/**
 * Type of batch job to execute
 */
export enum JobType {
    /**
     * Unspecified job type
     */
    Unspecified = 0,

    /**
     * Send email job
     */
    SendEmail = 1,

    /**
     * Create payment links job
     */
    CreatePaymentLinks = 2,

    /**
     * Send SMS job
     */
    SendSms = 3,

    /**
     * Create Fortnox invoices job
     */
    CreateFortnoxInvoices = 4,

    /**
     * Create Fortnox customers for members not yet in Fortnox
     */
    CreateFortnoxCustomers = 5,

    /**
     * Create Spiris invoice drafts job
     */
    CreateSpirisInvoices = 6
}
